import { TableColumnsType } from 'antd';
import { DataCertificatesICTSystem } from 'store/ducks/Reportings/types';

export const certificateColumnsICTSystemsFunctions: TableColumnsType<DataCertificatesICTSystem> =
  [
    {
      title: 'Certificate Description',
      width: 150,
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'ICT System name',
      width: 150,
      dataIndex: 'ict_system_name',
      key: 'ict_system_name',
    },
    {
      title: 'Function name',
      width: 150,
      dataIndex: 'function_name',
      key: 'function_name',
    },
    {
      title: 'ICT Service description',
      width: 150,
      dataIndex: 'ict_service_description',
      key: 'ict_service_description',
    },
    {
      title: 'Date of issuance',
      width: 150,
      dataIndex: 'date_of_issuance',
      key: 'date_of_issuance',
    },
    {
      title: 'Validity',
      width: 150,
      dataIndex: 'validity',
      key: 'validity',
    },
    {
      title: 'Certificate registry',
      width: 150,
      dataIndex: 'certificate_registry',
      key: 'certificate_registry',
    },
    {
      title: 'Date of certificate register',
      width: 150,
      dataIndex: 'date_of_certificate_register',
      key: 'date_of_certificate_register',
    },
    {
      title: 'Certificate Valid from',
      width: 150,
      dataIndex: 'start_date',
      key: 'start_date',
    },
    {
      title: 'Certificate Valid to',
      width: 150,
      dataIndex: 'end_date',
      key: 'end_date',
    },
  ];
